import { cn } from "@/lib/utils";
import { CopilotSymbol } from "./Logo/CopilotSymbol";
import { CopilotWord } from "./Logo/CopilotWord";

export function SidebarLogo({ isCollapsed }: { isCollapsed: boolean }) {
  return (
    <div className="flex w-[135px] h-[26px]">
      <CopilotWord
        className={cn(
          isCollapsed ? "w-0" : "w-[107px]",
          "transition-all duration-300 ease-in-out",
        )}
      />
      <CopilotSymbol className="w-[23px]" />
    </div>
  );
}
